import { useMemo } from 'react';

import { datachecksResolver } from 'support/helpers/resolvers/datachecksResolver';
import { DocumentType, RelationshipV2 } from 'support/types/dtos';

import { useProcessSpecification } from './useProcessSpecification';

export const useCreateDocumentSetup = ({
  relationship,
  sourceMessageId,
  documentType,
}: {
  relationship: RelationshipV2 | undefined;
  sourceMessageId?: string;
  documentType: DocumentType | undefined;
}) => {
  const receiverProcessSpecification = useProcessSpecification({
    relationshipId: relationship?.id,
    sourceMessageId,
  });

  const resolver = useMemo(
    () =>
      datachecksResolver({
        fieldsConfiguration: receiverProcessSpecification?.fields,
        withTimeout: true,
      }),
    [receiverProcessSpecification?.fields],
  );

  const isLoading = !relationship || !documentType;

  return {
    resolver,
    isLoadingSetup: isLoading,
    receiverProcessSpecification,
  };
};
